// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import File from './file';
import t from 'tcomb';

const InvoiceClaimsProcess = t.struct({
    approvedLabor: t.maybe(t.Number),
    approvedLaborAdditive: t.maybe(t.Number),
    approvedOtherCredits: t.maybe(t.Number),
    approvedParts: t.maybe(t.Number),
    approvedPartsAdditive: t.maybe(t.Number),
    approvedTravelTotal: t.maybe(t.Number),
    cgst: t.maybe(t.Number),
    claimNumber: t.String,
    claimType: KeyValuePair,
    currency: KeyValuePair,
    dateOfDealerInvoice: t.maybe(t.Number),
    dealerInvoiceNumber: t.maybe(t.String),
    exchangeRate: t.maybe(t.Number),
    file: t.maybe(File),
    gstPercentage: t.maybe(t.Number),
    harmcode: t.maybe(t.String),
    igst: t.maybe(t.Number),
    nonRecoverableTaxes: t.maybe(t.Number),
    pin: t.String,
    plant: t.String,
    recoverableTaxes: t.maybe(t.Number),
    referenceNumber1: t.String,
    referenceNumber2: t.String,
    sgst: t.maybe(t.Number),
    status: KeyValuePair,
    subClaimType: KeyValuePair,
    totalAmountInLocalCurrency: t.maybe(t.Number),
    totalApprovedClaimValue: t.maybe(t.Number),
    totalApprovedIncludingTaxes: t.maybe(t.Number),
    waitingForDealerInvoiceSince: t.maybe(t.Number),
    withholdValue: t.maybe(t.Number)
}, {
    name: 'InvoiceClaimsProcess',
    strict: true
});

export const getDefaultState = () => new InvoiceClaimsProcess({
    approvedLabor: 0,
    approvedLaborAdditive: 0,
    approvedOtherCredits: 0,
    approvedParts: 0,
    approvedPartsAdditive: 0,
    approvedTravelTotal: 0,
    cgst: null,
    claimNumber: '',
    claimType: getKeyValuePairDefaultState(),
    currency: getKeyValuePairDefaultState(),
    dateOfDealerInvoice: null,
    dealerInvoiceNumber: '',
    exchangeRate: null,
    file: null,
    gstPercentage: null,
    harmcode: '',
    igst: null,
    nonRecoverableTaxes: 0,
    pin: '',
    plant: '',
    recoverableTaxes: 0,
    referenceNumber1: '',
    referenceNumber2: '',
    sgst: null,
    status: getKeyValuePairDefaultState(),
    subClaimType: getKeyValuePairDefaultState(),
    totalAmountInLocalCurrency: 0,
    totalApprovedClaimValue: 0,
    totalApprovedIncludingTaxes: 0,
    waitingForDealerInvoiceSince: null,
    withholdValue: null
});

export default InvoiceClaimsProcess;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/invoice-claims-process.js